import * as yup from 'yup';

export const lenderContactFormValidation = () =>
  yup.object({
    id: yup.string().nullable(),
    firstName: yup.string().nullable().required(),
    middleName: yup.string().nullable(),
    lastName: yup.string().nullable().required(),
    email: yup.string().email().nullable().required(),
    phoneNumber: yup.string().min(10).max(10).nullable(),
    functions: yup.array().of(yup.string()).min(1).nullable(),
    notes: yup.string().nullable(),
  });
